import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'CustomDeleteButton',
  standalone: true,
  imports: [
    CommonModule, ButtonModule
  ],
  template: `
    <button pButton icon="pi pi-trash" (click)="handleClick($event)" [disabled]="disabled" 
      class="p-button-danger button-edit p-button-outlined"></button>
  `
})
export class CustomDeleteButton {
  @Input() item !: any;
  @Input() disabled : boolean = false;
  @Output() onClick = new EventEmitter<any>();

  handleClick(event: Event): void {
    this.onClick.emit({ event, item: this.item });
  }
}
